import { render, staticRenderFns } from "./Water-outage-details.vue?vue&type=template&id=07b0bd0c&scoped=true"
import script from "./Water-outage-details.vue?vue&type=script&lang=js"
export * from "./Water-outage-details.vue?vue&type=script&lang=js"
import style0 from "./Water-outage-details.vue?vue&type=style&index=0&id=07b0bd0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b0bd0c",
  null
  
)

export default component.exports